<div class="container" id="container" *ngIf="finishedLoading">

    <div class="row">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>Stammdatenänderung </mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="infoForm">
                    <div class="row">
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Status:</mat-label>
                                <input matInput type="text" formControlName="state">
                                <mat-error *ngIf="infoForm.get('state').hasError('required')">
                                    Status <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Ersteller:</mat-label>
                                <input matInput type="text" formControlName="creator">
                                <mat-error *ngIf="infoForm.get('creator').hasError('required')">
                                    Ersteller <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>

                    </div>

                    <div class="row">
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Erstellt am:</mat-label>
                                <input matInput type="date" formControlName="created">
                                <mat-error *ngIf="infoForm.get('created').hasError('required')">
                                    Erstellt am <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>

                        </div>

                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Letzte Änderung:</mat-label>
                                <input matInput type="date" formControlName="lastModified">
                                <mat-error *ngIf="infoForm.get('lastModified').hasError('required')">
                                    Letzte Änderung am <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>

                        </div>

                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div class="row marginTop2Rem">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>Meine persönlichen Angaben </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="row" [formGroup]="personFrom">
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Vorname:</mat-label>
                                <input matInput type="text" formControlName="firstName">
                                <mat-error *ngIf="personFrom.get('firstName').hasError('required')">
                                    Vorname <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Nachname:</mat-label>
                                <input matInput type="text" formControlName="lastName">
                                <mat-error *ngIf="personFrom.get('lastName').hasError('required')">
                                    Vorname <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row" [formGroup]="contactForm">
                        <div class="col-sm-3">
                            <mat-form-field class="full-width">
                                <mat-label>Telefon:</mat-label>
                                <input matInput type="number" formControlName="phone">
                                <mat-error *ngIf="contactForm.get('phone').hasError('required')">
                                    Telefon <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-3">
                            <mat-form-field class="full-width">
                                <mat-label>Telefon mobil:</mat-label>
                                <input matInput type="number" formControlName="phoneMobile">
                                <mat-error *ngIf="contactForm.get('phoneMobile').hasError('required')">
                                    Telefon mobil <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>E-Mail:</mat-label>
                                <input matInput type="text" formControlName="email">
                                <mat-error *ngIf="contactForm.get('email').hasError('required')">
                                    E-Mail <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                </mat-card-content>
            </mat-card>
        </div>
    </div>

    <div class="row marginTop2Rem">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>Vertragsdaten </mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="addressFrom">
                    <div class="row">
                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Kundennummer:</mat-label>
                                <input matInput type="text" formControlName="supplyContract">
                                <mat-error *ngIf="addressFrom.get('supplyContract').hasError('required')">
                                    Kundennummer <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Verbrauchstellennummer:</mat-label>
                                <input matInput type="text" formControlName="consumptionNumber">
                                <mat-error *ngIf="addressFrom.get('consumptionNumber').hasError('required')">
                                    Verbrauchstellennummer <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">

                            <mat-form-field class="full-width">
                                <mat-label>Strasse:</mat-label>
                                <input matInput type="text" formControlName="street">
                            </mat-form-field>
                        </div>

                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Postleitzahl:</mat-label>
                                <input matInput type="number" formControlName="postcode">
                            </mat-form-field>
                        </div>

                        <div class="col-sm-6">
                            <mat-form-field class="full-width">
                                <mat-label>Ort:</mat-label>
                                <input matInput type="text" formControlName="city">
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>


<div class="container" id="container" *ngIf="!finishedLoading">
    <div class="row">
        <div class="col-sm-12 padding">
            <div class="loadingOverlay">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>
</div>